import moment from 'moment-timezone';

export default (date, time) => {
    return `${moment(time, 'HH:mm:ss').format('h:mm A')}, ${moment.utc(date).tz('Asia/Kuala_Lumpur').format('dddd MMMM D YYYY')}`
};
